module.exports = __webpack_public_path__ + "3531e915c2ec6818464d658781bc6e7e.png";


//////////////////
// WEBPACK FOOTER
// ./content/ga4gh-logo-more.png
// module id = 1304
// module chunks = 0